import ReferralForm from '../ReferralForm/ReferralForm';
import './ReferralLandingPage.css';
import { useHistory } from 'react-router-dom'
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';
import Container from 'react-bootstrap/Container';
function ReferralLandingPage() {
    return (
        <>
            < Nav/>
              <Container>
            <div className='margin'>
                <div id='ref-disclaimer '>
                    <h1>Client Referral Form</h1>

                    <p> Referral Process Steps for Referring Agencies to the Furniture Mission of the Red River Valley (FMRRV):
                    This unique link should not be shared with outside agencies. We view you as a strong partner to help us
                    connect furniture to your clients following a crisis.
        </p>
                    <p>
                        <strong>1.</strong> Complete Online Referral Form. Remember, this link should NOT be shared.
        </p>
                    <p>
                        <strong>2.</strong> Clients must complete the referral form with the help of referral agency. Furniture Mission will follow up
                        with the referral request within 72 hours.
        </p>
                    <p>
                        <strong>3.</strong> Upon notification of approval (via email to referral partner), the client will need to contact Furniture Mission
                        of the Red River Valley via phone within 72 hours after the referral partner receives confirmation of the request
                        to schedule an appointment with the warehouse to pick up furniture. Once approved, the referral remains for 6 weeks.
                        It is the client's responsibility to be timely, to provide transportation for the furniture, and to safely secure the
                        furniture during transit.
        </p>
                    <p>
                        <span id='final-disclaimer'><strong>The form below is for designated referral partner agency use only!</strong></span>
                    </p>
                </div>
                <br />
                <ReferralForm />
            </div>
        </Container>
        < Footer />
        </>
    );
}

export default ReferralLandingPage;